import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { MonitorErrorGroup } from "@/types/ApiResponses/Monitor";

export interface GetMonitorErrorDetailParams {
  fingerprint: string;
}

// 404s (unknown/invalid fingerprint) surface as an axios error — the caller
// decides how to handle it (see `useMonitorErrorDetail`'s `enabled` guard).
export const getMonitorErrorDetail = async (
  props: QueryProps<GetMonitorErrorDetailParams>
): Promise<MonitorErrorGroup> => {
  const res = await api.client.get(
    `/monitor/errors/${props.params.fingerprint}`,
    { signal: props.signal }
  );
  return res.data;
};
